module.exports = __webpack_public_path__ + "assets/img/5b8064cbf256bfbcfdd8eab01ee60141.svg";